/**
 * @param input
 * @returns {{label: *, value: *}[]}
 */
export default function toOption(input) {
  return Object.keys(input).map(value => ({value, label: input[value]}));
}
